module.exports = __webpack_public_path__ + "static/pinkfairy4-37e8b38c3346356c790a0586a496b523.png";